import * as transliteration from 'transliteration';

const identifyValue = (value) => (value === null || value === undefined ? '' : String(value));

const getTranslator = () => {
  if (transliteration && typeof transliteration.transliterate === 'function') {
    return transliteration.transliterate;
  }
  if (typeof transliteration === 'function') {
    return transliteration;
  }
  return null;
};

const translatorFunction = getTranslator();

const transliterateText = (value, options) => {
  if (translatorFunction) {
    try {
      return translatorFunction(value, options);
    } catch (error) {
      console.warn('Transliteration failed, falling back to raw text', error);
    }
  }
  return identifyValue(value);
};

export default transliterateText;
